var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("brands"),
      _c(
        "section",
        { staticClass: "studio__section", attrs: { id: "intro" } },
        [
          _c("div", { staticClass: "studio__content" }, [
            _c("h1", { staticClass: "studio__content--title" }, [
              _vm._v("Short Stories Move")
            ]),
            _vm._m(1),
            _c(
              "button",
              {
                staticClass: "btn btn--purpleLight",
                on: { click: _vm.goToForm }
              },
              [_vm._v("Work with us")]
            )
          ])
        ]
      ),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "full__video" }, [
      _c(
        "div",
        {
          staticClass:
            "intro__content intro__content--mobile intro__content--studio"
        },
        [
          _c("div", { staticClass: "studioLogo" }, [
            _c("img", {
              attrs: {
                srcset:
                  "https://cdn.flixel.com/static/static-web/studios/flixelStudiosWhite2x.png" +
                  " 2x, " +
                  "https://cdn.flixel.com/static/static-web/studios/flixelStudiosWhite1x.png" +
                  " 1x"
              }
            })
          ])
        ]
      ),
      _c("div", { staticClass: "fluid__video" }, [
        _c(
          "div",
          {
            staticClass:
              "intro__content intro__content--desktop intro__content--studio"
          },
          [
            _c("div", { staticClass: "studioLogo" }, [
              _c("img", {
                attrs: {
                  srcset:
                    "https://cdn.flixel.com/static/static-web/studios/flixelStudios2X.png" +
                    " 2x, " +
                    "https://cdn.flixel.com/static/static-web/studios/flixelStudios1x.png" +
                    " 1x"
                }
              })
            ])
          ]
        ),
        _c("iframe", {
          attrs: {
            src:
              "https://media.flixel.com/cinemagraph/by005206u1ucmntzr22b?hd=true",
            allow: "autoplay"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "studio__content--text" }, [
      _c("p", [
        _vm._v(
          "Need help with a cinemagraph campaign? Looking for inspiration on how to use micro-video content? Our award-winning Flixel Studios team can do it all. From strategy and concepts, to capture and post ― we work with many of the world's top brands, agencies and photographers."
        )
      ]),
      _c("p", [
        _vm._v(
          "We’ll energize your brand through visual storytelling. Done well, the magic of cinemagraphs and micro-videos deliver real engagement and business results."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "studio__section" }, [
      _c("div", { staticClass: "studio__section--container" }, [
        _c("div", { staticClass: "studio__section--content" }, [
          _c("div", { staticClass: "studioItem__title" }, [
            _c("h2", [_vm._v("Cinemagraph activations")])
          ]),
          _c("div", { staticClass: "studioItem__desc" }, [
            _c("p", [
              _vm._v(
                "Cinemagraphs make for magical and fun brand activations. We create beautiful cinemagraph experiences that delight your guests and encourage social sharing. "
              )
            ]),
            _c("p", [
              _vm._v(
                "Flixel Studios has developed and executed both simple and elaborate cinemagraph photo booth experiences for leading brands like A&E, Disney, The Emmys, Facebook, HBO, Instagram, Lincoln, Marriott, Mashable, Panasonic, PepsiCo, and TED."
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "studio__section--image" }, [
          _c("div", { staticClass: "fluid__video studio__cinemagraph" }, [
            _c("iframe", {
              attrs: {
                src:
                  "https://media.flixel.com/cinemagraph/q8ezg6dmxelur92bg7wt?hd=true",
                allow: "autoplay"
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "studio__section" }, [
      _c(
        "div",
        { staticClass: "studio__section--container studio__section--reverse" },
        [
          _c("div", { staticClass: "studio__section--content" }, [
            _c("div", { staticClass: "studioItem__title" }, [
              _c("h2", [_vm._v("Stills to Motion")])
            ]),
            _c("div", { staticClass: "studioItem__desc" }, [
              _c("p", [
                _vm._v(
                  "We transform still photos and video into thumb-stopping cinemagraphs. Flixel Studios can review your company assets, stock library or video footage, and reimagine it as dynamic motion content ― with or without sound."
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "studio__section--image image--reverse" }, [
            _c(
              "div",
              {
                staticClass:
                  "fluid__video studio__cinemagraph studio__cinemagraph--marilyn"
              },
              [
                _c("iframe", {
                  attrs: {
                    src:
                      "https://media.flixel.com/cinemagraph/6zgfe6ow6pm2dr8o1sle?hd=true",
                    allow: "autoplay"
                  }
                })
              ]
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "studio__section" }, [
      _c("div", { staticClass: "studio__section--container" }, [
        _c("div", { staticClass: "studio__section--content" }, [
          _c("div", { staticClass: "studioItem__title" }, [
            _c("h2", [_vm._v("Custom Digital Campaigns")])
          ]),
          _c("div", { staticClass: "studioItem__desc" }, [
            _c("p", [
              _vm._v(
                "We help your brand become better storytellers by creating new ways to reach and engage with your target markets. Flixel Studios can create custom digital campaigns and content for TV, digital signage, the web, social media ads and more."
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "studio__section--image" }, [
          _c("div", { staticClass: "fluid__video studio__cinemagraph" }, [
            _c("iframe", {
              attrs: {
                src:
                  "https://media.flixel.com/cinemagraph/abog3firhfqn7imfm140/",
                allow: "autoplay"
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "studio__section", attrs: { id: "contactSection" } },
      [
        _c("div", { staticClass: "studio__contactform" }, [
          _c("div", { staticClass: "contactform" }, [
            _c("h1", [_vm._v("Contact Flixel Studios")]),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "mailto:mark@flixel.com?subject=Work with Flixel Studios"
                }
              },
              [
                _c("button", { staticClass: "btn btn--purpleLight" }, [
                  _vm._v("Contact Us")
                ])
              ]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20d81cda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d81cda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Studios.vue
// module id = null
// module chunks = 